import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';
import * as Util from '../../common/utilities/';
import { withSession } from '../../i18n/containers/AppInit.js';

import './Home.scss';

import { BrandBand } from '../../common/components';
import { ProfileAttributeList, Header, McMenu } from '../components/';

export class ProfileAttributeDashboard extends Component {
  componentDidMount() {
    const importType = this.props.flags.flags.ftpImport
      ? 'FtpImport'
      : 'DeImport';

    this.props.actions.getImports();
    this.props.actions.getImportConfiguration(importType);
    this.props.actions.getAttributes();
    this.props.actions.getRules();
  }

  componentDidUpdate(prevProps) {
    const importType = this.props.flags.flags.ftpImport
      ? 'FtpImport'
      : 'DeImport';

    if (Util.propChanged(prevProps, this.props, 'dataExtensions.data.status')) {
      if (
        ['queued', 'scheduled'].includes(this.props.dataExtensions.data.status)
      ) {
        this.props.actions.getAttributes();
        this.props.actions.getImports();
        this.props.actions.getImportConfiguration(importType);
        this.props.actions.getRules();
      }
    }
  }

  handleListAction(session) {
    return (action, attr) => {
      const attribute = { ...attr };
      if (!attribute?.values?.length) {
        attribute.values = [''];
      }
      switch (action) {
        case 'edit':
          this.props.actions.openModal('attributeEdit', {
            attribute,
            original: { ...attribute }
          });
          break;
        case 'delete':
          this.props.actions.deleteAttribute(attribute, {
            callback: this.props.actions.getAttributes,
            cToken: session.cToken
          });
          break;
        default:
          break;
      }
    };
  }

  render() {
    const { profileAttributes, filter, lastSave } = this.props.attributes.data;
    const { isLoading, isSaving } = this.props.attributes;

    return withSession(session => {
      return (
        <McMenu
          flags={this.props.flags}
          history={this.props.history}
          route="/attributes/profile"
        >
          <BrandBand>
            <Header route={this.props.match} />
            <ProfileAttributeList
              actions={this.props.actions}
              attributes={profileAttributes || []}
              rules={this.props.rules}
              dataExtensions={this.props.dataExtensions}
              lastImport={this.props.imports?.data?.lastDeImport}
              importConfiguration={this.props.importConfiguration}
              filter={filter}
              isLoading={isLoading}
              isSaving={isSaving}
              lastSave={lastSave}
              onListAction={this.handleListAction(session)}
              modals={this.props.modals}
              toast={this.props.toast}
              location={this.props.location}
            />
          </BrandBand>
        </McMenu>
      );
    });
  }
}

ProfileAttributeDashboard.contextTypes = {
  router: PropTypes.object
};

ProfileAttributeDashboard.propTypes = {
  actions: PropTypes.shape({
    getAttributes: PropTypes.func,
    openModal: PropTypes.func
  }),
  attributes: PropTypes.object.isRequired,
  dataExtensions: PropTypes.object.isRequired,
  flags: PropTypes.object,
  imports: PropTypes.object.isRequired,
  importConfiguration: PropTypes.object.isRequired,
  rules: PropTypes.object.isRequired,
  modals: PropTypes.object,
  toast: PropTypes.object,
  location: PropTypes.object
};

function mapStateToProps(state) {
  return {
    attributes: state.ecs.attributes,
    dataExtensions: state.ecs.dataExtensions,
    imports: state.ecs.imports,
    importConfiguration: state.ecs.importConfiguration,
    rules: state.ecs.rules,
    modals: state.modals,
    flags: state.ecs.flags,
    toast: state.toast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileAttributeDashboard);
